// extracted by mini-css-extract-plugin
export default {"BoxMakerForm":"BoxMakerForm_BoxMakerForm__ZGo7f"};